import { render, staticRenderFns } from "./SurveysShow.vue?vue&type=template&id=bb30fc16&"
import script from "./SurveysShow.vue?vue&type=script&lang=js&"
export * from "./SurveysShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports